"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tfoot = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function Tfoot(props) {
    return jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "tfoot", backgroundColor: "rgba(125,125,125,0.05)" }, props), void 0);
}
exports.Tfoot = Tfoot;
//# sourceMappingURL=index.js.map